export function isInitialZoom<T extends [Date, Date] | [number, number]>(
  currentDomain: T | undefined,
  initialDomain: T | undefined,
) {
  if (currentDomain === undefined || initialDomain === undefined) {
    return false;
  }

  return (
    +currentDomain[0] === +initialDomain[0] &&
    +currentDomain[1] === +initialDomain[1]
  );
}
